import { ReportDetails } from "@idwal/idwal-react-components";
import { ReactElement, useMemo } from "react";
import { LoadingParticulars } from "../loading/LoadingParticulars";
import { useParams } from "react-router-dom";
import { showRequestErrorToast } from "../../services/ErrorService";
import { useQuery } from "react-query";
import DataRequest from "../../queries/DataRequest";
import { VesselParticularsResponse } from "../../types/responses/VesselParticularsResponse";
import dayjs from "dayjs";

export const VesselParticulars = (): ReactElement => {
    const { inspectionId } = useParams();

    const { data, isError, isLoading, error } =
        useQuery<VesselParticularsResponse>(["particulars"], () =>
            DataRequest(inspectionId as string, "particulars")
        );

        const formatDate = (date: string | undefined) =>
            date ? dayjs(date).format("DD MMMM YYYY") : "";
    
        const getDate = (dateFromString: string, dateToString: string) => {
            if (!dateToString) {
                return formatDate(dateFromString);
            }
    
            return `${formatDate(dateFromString)} - ${formatDate(dateToString)}`;
        };
    
        const reportDetails = useMemo(
            () =>
                data
                    ? {
                          Grade: data.Grade,
                          GradeImageUrl: data.GradeImageUrl,
                          ShipName: data.ShipName,
                          InspectionType: data.InspectionType,
                          Details: [
                              {
                                  key: "imoNumber",
                                  value: data.IMONumber,
                                  selector: "imo"
                              },
                              {
                                  key: "inspectionType",
                                  value: data.InspectionType,
                                  selector: "inspection-type"
                              },
                              {
                                  key: "inspectionRef",
                                  value: data.InspectionNumber,
                                  selector: "inspection-number"
                              },
                              {
                                  key: "inspectionIssuedAt",
                                  value: formatDate(data.InspectionIssuedAt),
                                  selector: "issued-at"
                              },
                              {
                                  key: "inspectedAt",
                                  value: data.InspectedAt,
                                  selector: "inspected-at"
                              },
                              {
                                  key: "date",
                                  value: getDate(
                                      data.InspectedDateFrom,
                                      data.InspectedDateTo
                                  ),
                                  selector: "inspected-date"
                              },
                              {
                                  key: "technicalManager",
                                  value: data.TechnicalManager,
                                  selector: "manager"
                              },
                              {
                                  key: "registeredOwner",
                                  value: data.RegisteredOwner,
                                  selector: "registered-owner"
                              }
                          ]
                      }
                    : undefined,
            [data]
        );
    
        if (isLoading) {
            return <LoadingParticulars />;
        }
    
        if (isError) {
            console.error(error);
            showRequestErrorToast("toasts.vesselParticularsNotLoaded");
            return <></>;
        }
    
        if (reportDetails) {
            return isLoading ? (
                <LoadingParticulars />
            ) : (
                <ReportDetails reportDetails={reportDetails} />
            );
        }
    
        return <LoadingParticulars />;
};
